import { render, staticRenderFns } from "./ModelField.vue?vue&type=template&id=4f1dbcde"
import script from "./ModelField.vue?vue&type=script&lang=ts"
export * from "./ModelField.vue?vue&type=script&lang=ts"
import style0 from "./ModelField.vue?vue&type=style&index=0&id=4f1dbcde&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports